var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.topbar,staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"}},[_c('div',{},[_c('air-user-menu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }